import { createStore } from "vuex"
import FundNowModule from "./modules/fundnow.js"

export default createStore({
  modules: {
    fundnow: FundNowModule,
  },
})
